/// <reference types="@types/googlemaps" />

import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';


import { AnalysisService } from '../services/analysis.service';
import { PprService } from '../services/ppr.service';

import { ToastrService } from 'ngx-toastr';
import { ModalReadPprComponent } from '../modal-read-ppr/modal-read-ppr.component';

import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'app-ppr',
  templateUrl: './ppr.component.html',
  styleUrls: ['./ppr.component.css']
})
export class PprComponent implements OnInit {

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private translate: TranslateService,
    private analysisService: AnalysisService,
    private pprService: PprService,
    private toastr: ToastrService,
    private modal: NgbActiveModal,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon("back", this.domSanitizer.bypassSecurityTrustResourceUrl(this.homeImage));
    this.matIconRegistry.addSvgIcon("all", this.domSanitizer.bypassSecurityTrustResourceUrl(this.summaryImage));
    this.matIconRegistry.addSvgIcon("Analysis", this.domSanitizer.bypassSecurityTrustResourceUrl(this.analysisImage));
    this.matIconRegistry.addSvgIcon("MDI", this.domSanitizer.bypassSecurityTrustResourceUrl(this.mdiImage));
    this.matIconRegistry.addSvgIcon("PPR", this.domSanitizer.bypassSecurityTrustResourceUrl(this.pprImage));
    this.matIconRegistry.addSvgIcon("ROI", this.domSanitizer.bypassSecurityTrustResourceUrl(this.roiImage));
  }

  //LocalStorage Elements.
  localFacilities = localStorage.getItem('localFacilities');
  localID = localStorage.getItem('localID');
  localModules = localStorage.getItem('localModules');

  id = JSON.parse(this.localID);
  facilities = JSON.parse(this.localFacilities);
  modules = JSON.parse(this.localModules);
  currentFacility = this.facilities[this.id];

  timelineMessage = '';

  //Icon NavBar
  markerImage: any = require("../image/logo/locationIcon.png");
  homeImage: any = require("../image/navbar/backHomeIcon.svg");
  summaryImage: any = require("../image/navbar/summary.svg");
  analysisImage: any = require("../image/navbar/analysis.svg");
  roiImage: any = require("../image/navbar/roi.svg");
  mdiImage: any = require("../image/navbar/mdi.svg");
  pprImage: any = require("../image/navbar/ppr.svg");

  lng: any;
  lat: any;
  zoom: number;

  today = new Date();
  timeline: any;
  page: number = 1;

  itemTimeline: Array<any> = [];
  currentPage: number = 0;
  itemsNumberPerPage: number = 10;

  modalReference: any;

  partialState: null;
  notStartedState: null;

  analysisStatus = null;

  isOpen: boolean;
  _opened: boolean = false;

  module: string = 'PPR';
  idElaboration: number;
  pprTypes: any;
  typeSelected: string;
  datePickerShow: boolean;

  customdatestart: string;
  customdateEnd: string;

  pprDataset: any;


  minDate = new Date(this.today.getUTCFullYear(), this.today.getUTCMonth() + 1, 1);
  maxDate = new Date(this.today.getUTCFullYear(), this.today.getUTCMonth() + 13, 10);
  dateSelected: string;


  ngOnInit() {

    this.translate.use(localStorage.getItem('localLanguage'));

    this.createGoogleMap();

    this.getTimeline(this.currentPage);
  }

  _toggleSidebar() {
    this._opened = !this._opened;
  }

  cardStructureOpen() {
    this.isOpen = true;
  }

  cardStructureClose() {
    this.isOpen = false;
  }

  //Method used to create a map of current Structure.
  createGoogleMap() {
    if (navigator) {
      this.lng = this.currentFacility.myFacilities.Longitude;
      this.lat = this.currentFacility.myFacilities.Latitude;
      this.zoom = 13;
    }
  }

  //Method used to scrolled Timline of current facility.
  onScroll(event) {
    if ((event.target.scrollHeight - event.target.scrollTop) === event.target.clientHeight) {
      this.currentPage++;
      this.getTimeline(this.currentPage);
    }
  }

  //API Return Timeline
  getTimeline(currentPage: number) {
    //Call Api of Analys service to get Timeline of current facility.
    this.analysisService.getTimeline(this.currentFacility.myFacilities.IdAnalysis, this.modules, currentPage, this.itemsNumberPerPage)
      .subscribe(
        data => {
          this.timeline = data;

          for (let item of this.timeline.items)
            this.itemTimeline.push(item);

          this.checkReportStatus(this.timeline);
        },
        error => {
          this.timelineMessage = error.error;
          //this.router.navigate(['/errorPage']);
        }
      );
  }

  //Method that check last item of timeline with state: Report.
  checkReportStatus(timeline: any) {
    for (let itemTimeline of timeline.items) {
      if (itemTimeline.state === 'Report') {
        this.idElaboration = itemTimeline.id;
        break;
      }
    }
  }

  //API return PPR Type.
  getPprRequest(content) {
    this.datePickerShow = false;

    this.pprService.getPprTypes()
      .subscribe(
        data => {
          this.pprTypes = data;
          console.log(this.pprTypes);
          this.modalReference = this.modalService.open(content, { centered: true, size: 'lg' });
        },
        error => {
          console.log(error);
        });
  }

  //Method used to close Modal of Request PPR.
  close() {
    this.modalReference.close();
  }

  //Method that return type selected from radio button.
  getTypePPRFromRadioButton(event) {
    this.typeSelected = event.value;
    this.datePickerShow = false;


    if (this.typeSelected === 'CustomPrezzi') {
      this.datePickerShow = true;
    }


    if (this.typeSelected === 'CustomPresenze') {
      this.datePickerShow = true;
    }
  }


  dateChange(event: MatDatepickerInputEvent<Date>) {
    const customStartDateString = this.today.toISOString().split("-");
    const monthStartData = Number(customStartDateString[1]) + 1;
    const yearStartData = customStartDateString[0];
    const dateEventValue = event.value.toISOString().split("-");

    this.customdatestart = yearStartData + '-' + monthStartData + '-' + "2"
    this.customdateEnd = dateEventValue[0] + '-' + dateEventValue[1] + '-' + "2";
  }

  //API PPR Request.
  sendPprRequest() {
    let dateStart = null;
    let dateEnd = null;
    if (!this.typeSelected) return;

    switch (this.typeSelected) {
      case 'CustomPrezzi': {
        dateStart = this.customdatestart;
        dateEnd = this.customdateEnd;
        break;
      }
      case 'CustomPresenze': {
        dateStart = this.customdatestart;
        dateEnd = this.customdateEnd;
        break;
      }
      default: {
        dateStart;
        dateEnd;
        break;
      }
    }

    this.pprService.requestPPR(this.module, this.currentFacility.myFacilities.ID, this.idElaboration, this.typeSelected, dateStart, dateEnd)
      .subscribe(
        data => {
          this.getTimeline(this.currentPage);
          this.close();
        },
        error => {
          this.router.navigate(['/errorPage']);
        });
  }


  //Open modal Read PPR
  pprRead(content, reportId) {
    this.pprService.viewPPR(reportId)
      .subscribe(
        data => {
          //let dateString = timestamp.split("-");
          //let dateRequestPPR = dateString[0] + '/' +
          this.pprDataset = data;
          const modalRef = this.modalService.open(ModalReadPprComponent, { centered: true, size: 'lg' })
          modalRef.componentInstance.pprDataset = this.pprDataset;
        },
        error => {
          this.router.navigate(['/errorPage']);
        });
  }
}
